// src/stores/Factors.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";
import { useConfirm } from "../composables";

export const useAuthenticateStore = defineStore("Authenticate", () => {
    const toast = useToast();
    const loading = ref(false);

    async function sendOtpForChangePassword(payload) {
        loading.value = true;
        try {
            const response = await apiClient.post('Authenticate/SendOtpForChangePassword', payload);
            if (response.status === 200) {
                toast.success("کد تایید برای تغییر کلمه عبور ارسال شد ");
            } else {
                toast.error("خطا در ارسال کد تایید");
            }
        } catch (error) {
            toast.error("خطا در ارسال کد تایید");
        } finally {
            loading.value = false;
        }
    }
    async function sendOtpForForgotPassword(payload) {
        loading.value = true;
        try {
            const response = await apiClient.post('Authenticate/SendOtpForForgotPassword', payload);
            if (response.status === 200) {
                toast.success("کد تایید برای فراموشی کلمه عبور ارسال شد ");
            } else {
                toast.error("خطا در ارسال کد تایید");
            }
        } catch (error) {
            toast.error("خطا در ارسال کد تایید");
            throw error;
        } finally {
            loading.value = false;
        }
    }
    async function changePassword(payload) {
        loading.value = true;
        try {
            const response = await apiClient.post('Authenticate/ChangePassword', payload);
            if (response.status === 200) {
                toast.success('کلمه عبور با موفقیت تغییر یافت');
            } else {
                toast.error("خطا در تغییر کلمه عبور");
            }
        } catch (error) {
            toast.error("خطا در تغییر کلمه عبور");
        } finally {
            loading.value = false;
        }
    }
    async function ChangeForgotPassword(payload) {
        loading.value = true;
        try {
            const response = await apiClient.post('Authenticate/ChangeForgotPassword', payload);
            if (response.status === 200) {
                toast.success('رمز عبور جدید با موفقیت ثبت شد');
            } else {
                toast.error("خطا در تغییر کلمه عبور");
            }
        } catch (error) {
            toast.error("خطا در تغییر کلمه عبور");
            throw error;
        } finally {
            loading.value = false;
        }
    }
    return {
        sendOtpForChangePassword,
        sendOtpForForgotPassword,
        ChangeForgotPassword,
        changePassword
    }
})
